import React, { useState, useEffect, useRef } from "react";
import { useHistory  } from "react-router-dom";
import styles from "./ECatalogNavigation.module.css";
import { CartProvider, useCart } from "react-use-cart";
import { BiCartAlt } from "react-icons/bi";
import {
  getAzureConfig,
  LoginConfiguration,
} from "../../Services/ConfigurationService";

import {
  Breadcrumb,
  Layout,
  Menu,
  Button,
  Badge,
  Avatar,
  Popover,
  Modal,
} from "antd";
import { ButtonNavigation } from "../ButtonNav/ButtonNavigation";
import { ButtonNavigationDropdown } from "../ButtonNav/ButtonNavigationDropdown";
import { useUserContext } from "../../Context/UserContext";
import { useSessionContext } from "../../Context/AuthContext";
import { IoLogOutSharp, IoMailOutline, IoPersonOutline } from "react-icons/io5";
import Cookies from "universal-cookie";
import { clearLocalStorageOnLogout } from "../../Helper/localStoreFunction";
import type { MenuProps } from "antd";
import { useMsal } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { useECatalogContext } from "../../Context/ECatalogContext";
import $ from "jquery";
const { Header, Content, Footer, Sider } = Layout;

// import logo from '../../assets/logotrcs_150px_new1.jpg';

interface Props {
  //responeConfig: any;
}
interface AzureConfig {
  c: string;
  s: string;
  w: string;
}
export const ECatalogNavigation = (props: Props) => {
  const [userData, setUserData] = useUserContext();
  const [popOverClick, setPopOverClick] = useState<boolean>(false);
  const [shortNameUser, setShortNameUser] = useState<string>("");
  const [sessionState, setSessionState] = useSessionContext();
  const [responeConfig, setResponeConfig] = useState<any>();
  const [auzreConfig, setAuzreConfig] = useState<AzureConfig>();
  const { instance, accounts } = useMsal();
  const history = useHistory();
  const cookies = new Cookies();
  const checkEcatalog = useECatalogContext();
  const [isAuthorize, setIsAuthorizeo] = useState(true);
  const [isEditECatalog, setIsEditECatalog] = useState(true);
  const { t } = useTranslation(["translation"]);
  const menuItem = [
    { key: 1, label: "หน้าแรก" },
    //{ key: 2, label: "ประวัติการขอซื้อ" },
    // { key: 3, label: "คู่มือการใช้งาน" }
  ];
  const { isEmpty, totalItems } = useCart();
  useEffect(() => {
    $("#root > .navbar-container").hide();
    fetchCon().then(([responeConfig, reponseAzureConfig]) => {
      setAuzreConfig(reponseAzureConfig);
      setResponeConfig(responeConfig);
      if (
        responeConfig?.titleWeb !== "" &&
        responeConfig?.titleWeb !== undefined &&
        responeConfig?.titleWeb != null
      ) {
        document.title = responeConfig?.titleWeb;
      }
      if (
        responeConfig?.pathFavicon !== "" &&
        responeConfig?.pathFavicon !== undefined &&
        responeConfig?.pathFavicon != null
      )
        document
          .querySelector('link[rel="shortcut icon"]')
          ?.setAttribute("href", responeConfig?.pathFavicon);
    });
  }, []);
  useEffect(() => {
    if (userData) {
      initialNameUser();
    }
  }, [userData]);
  useEffect(() => {
    if (checkEcatalog.roleData != null) {
      setIsAuthorizeo(checkEcatalog.canAccess);
      setIsEditECatalog(checkEcatalog.canEdit);
    }
  }, [checkEcatalog]);
  const initialNameUser = () => {
    if (userData) {
      let name = userData.NameEn || "";
      const fullName: any[] | ["", ""] = name.split(" ");
      let firstName = "";
      let lastName = "";
      for (let i = 0; i < fullName.length; i++) {
        if (i === 0) {
          firstName = fullName[i].slice(0, 1).toUpperCase();
        }
        if (i === 1) {
          lastName = fullName[i].slice(0, 1).toUpperCase();
        }
      }
      setShortNameUser(firstName + lastName);
    }
  };
  const fetchCon = async () => {
    var responeConfig = await LoginConfiguration();
    const reponseAzureConfig = await getAzureConfig();
    return [responeConfig, reponseAzureConfig];
  };
  const NavbarDesktop = () => {
    return (
      <>
        <div
          className="logo-container desktop"
          onClick={() =>   
              //history.replace ("/Default")
              window.location.href = "/Default"
            }
        >
          <img
            style={{
              width: `${responeConfig?.cssConfig?.width}`,
              height: "70px",
            }}
            className="img-logo"
            //src={responeConfig?.pathLogoNav}
            src="../Assets/Images/LOGOTHAILIFETH.png"
            alt="logo"
          />
        </div>
        <div
          className="e-cat-title"
          style={{
            alignContent: "center",
            width: "100%",
            fontSize: "x-large",
            color: "black",
            display: "none",
            justifyContent: "flex-end",
            paddingTop: "15px",
          }}
        >
          ระบบ e-Procurement
        </div>
        <div className="button-navbar-container desktop">
          <div>
            {isEditECatalog && (
              <button
                className="button-nav -active"
                id="Settings"
                onClick={() => {
                  history.push(`/cart`);
                }}
              >
                <Badge count={totalItems}>
                  <BiCartAlt />
                </Badge>
              </button>
            )}
          </div>
        </div>
        <div className="profile-container desktop">
          <Popover
            placement="bottomRight"
            content={userPopupContent}
            trigger="click"
            visible={popOverClick}
            onVisibleChange={handleClickChange}
            overlayInnerStyle={{ borderRadius: "6px" }}
          >
            <div className="profile-button">
              <p className="profile-name">{shortNameUser}</p>
            </div>
          </Popover>
          {/* <div className="profile-button">
                <p className="profile-name">{shortNameUser}</p>
              </div> */}
        </div>
      </>
    );
  };
  const userPopupContent = () => {
    return (
      <div className="main-user-popup-content">
        <div className="user-popup-content">
          <div className="user-popup-content-display">
            <IoPersonOutline className="icon-margin-top" />
            <p
              className="text-account-name icon-margin-left"
              style={{ fontSize: "20px" }}
            >
              {userData?.NameEn}
            </p>
          </div>
          <div className="user-popup-content-display">
            <IoMailOutline className="icon-margin-top " />
            <p
              className="text-account-mail icon-margin-left"
              style={{ fontSize: "20px" }}
            >
              {userData?.Email}
            </p>
          </div>
        </div>
        <div className="popup-button-box">
          {/* change Pass */}
          <div
            className="popup-container"
            onClick={() => signOutClickHandler(instance)}
          >
            <div className="circle">
              <IoLogOutSharp />
            </div>
            <p className="text-logout">{t("Logout")}</p>
          </div>
        </div>
      </div>
    );
  };
  const signOutClickHandler = async (instance: any) => {
    var respone = await LoginConfiguration();
    const baseurl = window.location.origin.toString();
    cookies.remove("GuidVerify");
    clearLocalStorageOnLogout();
    setSessionState({ ...sessionState, isAuthenticated: false });
    //AzureLogout
    if (respone.type === "LoginAzure") {
      const logoutRequest = {
        account: instance.getAccountByHomeId(accounts[0]?.homeAccountId),
        postLogoutRedirectUri: `${baseurl}/login`,
      };
      await instance.logoutRedirect(logoutRequest);
    }
    setPopOverClick(false);

    //GoogleLogout
    // googleAuth?.signOut();
  };
  const handleClickChange = (visible: boolean) => {
    //setPopOverHover(false);
    setPopOverClick(visible);
  };

  const onMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "1") history.push(`/ECatalog`);
  };

  return (
    <>
      {sessionState.isAuthenticated /*&& !shouldHideNavbar*/ && (
        <>
          <div
            id={styles.mainNav}
            className={`navbar-container -active`}
            style={{
              //backgroundColor: responeConfig?.pathNavbarColor,
              // borderBottom: "4px solid #red",
              //borderBottom: "4px solid #c95558",
              backgroundColor: "white",
            }}
          >
            {NavbarDesktop()}
          </div>
          <div className="div-site-navigation-main">
            <Menu
              style={{ display: "block" }}
              className={styles.site_navigation_main}
              mode="horizontal"
              //defaultSelectedKeys={["1"]}
              onClick={onMenuClick}
              items={menuItem}
            />
          </div>
        </>
      )}
    </>
  );

  // return (
  //     <Header style={{ height: "100%" }} className="site-header">
  //             <div>
  //                 <div className="site-identity">
  //                     <a href="/Ecatalog">
  //                         <img
  //                             src={logo}
  //                             alt="ระบบจัดซื้อจัดจ้างอิเล็กทรอนิกส์ e-Procurement สภากาชาดไทย"
  //                         />
  //                     </a>
  //                     <h1>
  //                         ระบบจัดซื้อจัดจ้างอิเล็กทรอนิกส์ e-Procurement สภากาชาดไทย
  //                     </h1>
  //                 </div>
  //                 <div className="site-navigation">
  //                     <nav className="">
  //                         <ul className="nav">
  //                             <li style={{marginRight: "10px", cursor:"pointer"}} onClick={() => { history.push(`/cart`); } }>
  //                                 <Badge count={totalItems} >
  //                                 <Avatar shape="square" size="large" icon={<BiCartAlt />} />
  //                                 </Badge>

  //                             </li>
  //                             <li>
  //                                 {/* <a href="#">เข้าสู่ระบบ</a> */}
  //                                 <Button
  //                                     type="primary"
  //                                     shape="round"
  //                                     size={"large"}
  //                                     className="login-button"
  //                                     onClick={() => { window.location.href = '/login' }}
  //                                 >
  //                                     AD
  //                                 </Button>
  //                             </li>
  //                         </ul>
  //                     </nav>
  //                 </div>
  //             </div>
  //             <div className="div-site-navigation-main" >
  //                 <Menu style={{display: "block"}}
  //                     className="site-navigation-main"
  //                     mode="horizontal"
  //                     defaultSelectedKeys={["1"]}
  //                     items={menuItem}
  //                 />
  //             </div>
  //         </Header>

  // )
};
